import JsxHelper from '../../../Helpers/JsxHelper';
import paidOutsideOfSystemHelper from '../../../Helpers/paidOutsideOfSystemHelper';
import React from 'react';
import LongText from '../../../Elements/LongText';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import stringHelper from '../../../Helpers/stringHelper';
import RedirectLinkComponent from '../../../Elements/RedirectLinkComponent';
import FigmaBadge from '../../../Elements/FigmaBadge';
import DataTableActionMenu from '../../../Elements/DataTable/DataTableActionMenu';
import AuthService from '../../../Services/authService';
import urlHelper from '../../../Helpers/urlHelper';
import LookupText from '../../../Elements/LookupText';

export default class TpJobItem {
  constructor(item) {
    if (item === undefined) {
      this.TpJobId = '';
      this.ThirdPartyJobId = '';
      this.ThirdPartySource = '';
      this.CaspianClientDetails = '';
      this.ThirdPartyLocationName = '';
      this.ThirdPartyJobStatus = '';
      this.FieldworkOfficeName = '';
      this.FieldworkOfficeId = '';
      this.DateAssigned = '';
      this.ThirdPartyEvaluatorId = '';
      this.EvaluatorGrade = '';
      this.SelfAssigned = '';
      this.ProcessedScore = '';
      this.PayEvaluator = '';
      this.ThirdPartyEvaluatorFee = '';
      this.ThirdPartyEvaluatorBonus = '';
      this.ThirdPartyLocationAddress = '';
      this.ThirdPartyLocationCity = '';
      this.ThirdPartyLocationState = '';
      this.ThirdPartyLocationCountry = '';
      this.ThirdPartyLocationZipCode = '';
      this.ThirdPartyLocationPhone = '';
      this.ThirdPartyClientLocationId = '';
      this.ThirdPartyLocationIsActive = '';
      this.ThirdPartyLevel1Id = '';
      this.ThirdPartyLevel2Id = '';
      this.ThirdPartyLevel3Id = '';
      this.ThirdPartyLevel4Id = '';
      this.ThirdPartyLevel5Id = '';
      this.JobDate = '';
      this.OpportunityCurrencyId = '';
      this.OpportunityCurrencyCode = '';
      this.OpportunityCurrencySymbol = '';
      this.ClientFeeTotal = '';
      this.ReimbTotal = '';
      this.FieldworkFee = '';
      this.ReimbursementCurrencyId = '';
      this.ReimbursementCurrencySymbol = '';
      this.EvaluatorCurrencySymbol = '';
      this.EvaluatorCurrencyCode = '';
      this.EvaluatorCurrencyId = '';
      this.EvalFeeTotal = '';
      this.EvalReimbTotal = '';
      this.ClientFeeBase = '';
      this.ClientFeeBaseWithSymbol = '';
      this.Selected = false;
      this.IsUninvoiceable = '';
      this.PaidOutsideOfSystem = '';
      this.CanTogglePaidOutsideOfSystem = false;
      this.IsShopperPaidThroughApollo = false;
      this.PricingCurrencySymbol = '';
      this.PricingCurrencyCode = '';
      this.TpWaveId = '';
      this.TpWaveName = '';
      this.TpWaveNameAndId = '';
      this.ProjectId = '';
      this.ProjectName = '';
      this.TpSurveyId = '';
      this.TpSurveyName = '';
      this.ProjectInvoiceAutomationIsActive = null;
      this.ProjectInvoiceAutomationRunSchedule = null;
      this.ProjectInvoiceAutomationInvoicedWithProjectId = null;
      this.ProjectInvoiceAutomationInvoicedWithProjectName = null;
      this.PricingId = '';
      this.RoundFee = '';
      this.ReimbursementCurrencyCode = '';
      this.TpClientInvoiceId = '';
      this.TpEvaluatorFullName = '';
      this.AsCuid = '';
      this.ThirdPartyDeleted = '';
      this.BillClient = '';
      this.Reimbursement = '';
      this.Status = '';
      this.Misc = '';
      this.CurrencyCode = '';
      this.Travel = '';
      this.ClientFee = '';
      this.Gaming = '';
      this.AdditionalClientFeeTotal = '';
      this.ExpenseCurrencyCode = '';
      this.EvaluatorReimbursement = '';
      this.EvaluatorTravel = '';
      this.EvaluatorGaming = '';
      this.FeeCurrencyCode = '';
      this.ExpenseCurrencyCode = '';
      this.EvaluatorMisc = '';
      this.EvaluatorFee = '';
      this.FieldworkFee = '';
      this.PricingDetails = '';
      this.GeneralFieldWorkFee = '';
      this.OwningOffice = '';
      this.OwningOfficeFee = '';
      this.EvaluatorFeeAdjustment = '';
      this.EvaluatorIds = '';
      this.TpClientInvoiceStatus = '';
      this.MiscTotal = '';
      this.TravelTotal = '';
      this.GamingTotal = '';
      this.TpClientInvoiceJobLineCurrencyCode = '';
      this.OwningOfficeName = '';
      this.ClientReimbursementCurrencyCode = '';
      this.ClientFeeCurrency = '';
      this.EvaluatorFeeCurrencyCode = '';
      this.TotalDue = '';
      this.TaxTotal = '';
      this.CurrentTotalDue = '';
      this.Credit = '';
      this.TpLocationId = '';
      this.ThirdPartySurveyId = '';
      this.TpEvaluatorTpJobPaymentDetailExportDate = '';
      this.TpEvaluatorTpJobPaymentDetailReimbursement = '';
      this.TpEvaluatorTpJobPaymentDetailTotal = '';
      this.TpEvaluatorTpJobPaymentStatusCodeLookupValue = '';
      this.TpEvaluatorTpJobPaymentDetailMisc = '';
      this.TpEvaluatorTpJobPaymentDetailTravel = '';
      this.TpEvaluatorTpJobPaymentDetailGaming = '';
      this.TpEvaluatorTpJobPaymentDetailCurrencyId = '';
      this.TpEvaluatorTpJobPaymentDetailFee = '';
      this.TpEvaluatorTpJobPaymentDetailFeeAdjustment = '';
      this.TpEvaluatorTpJobPaymentDetailVat = '';
      this.TpEvaluatorTpJobPaymentDetailDue = '';
      this.HasCollabJob = false;
      this.CollabJobThirdPartyId = '';
      this.CollabJobStatus = '';
      this.CollabJobThirdPartySource = '';
      this.AdHocInvoiceGroup = '';
      this.EvaluatorOfficeName = '';
      this.CampaignName = '';
      return;
    }

    this.TpJobId = item.tpJobId;
    this.ThirdPartyJobId = item.thirdPartyJobId;
    this.ThirdPartySource = item.thirdPartySource;
    this.CaspianClientDetails = item.caspianClientDetails ? item.caspianClientDetails : '';
    this.ThirdPartyLocationName = item.thirdPartyLocationName;
    this.ThirdPartyJobStatus = item.thirdPartyJobStatus;
    this.FieldworkOfficeName = item.fieldworkOfficeName;
    this.FieldworkOfficeId = item.fieldworkOfficeId;
    this.DateAssigned = item.dateAssigned;
    this.ThirdPartyEvaluatorId = item.thirdPartyEvaluatorId;
    this.EvaluatorGrade = item.evaluatorGrade;
    this.SelfAssigned = item.selfAssigned;
    this.ProcessedScore = item.processedScore;
    this.PayEvaluator = item.payEvaluator;
    this.ThirdPartyEvaluatorFee = item.thirdPartyEvaluatorFee;
    this.ThirdPartyEvaluatorBonus = item.thirdPartyEvaluatorBonus;
    this.ThirdPartyLocationAddress = item.thirdPartyLocationAddress;
    this.ThirdPartyLocationCity = item.thirdPartyLocationCity;
    this.ThirdPartyLocationState = item.thirdPartyLocationState;
    this.ThirdPartyLocationCountry = item.thirdPartyLocationCountry;
    this.ThirdPartyLocationZipCode = item.thirdPartyLocationZipCode;
    this.ThirdPartyLocationPhone = item.thirdPartyLocationPhone;
    this.ThirdPartyClientLocationId = item.thirdPartyClientLocationId ? item.thirdPartyClientLocationId : '?';
    this.ThirdPartyLocationIsActive = item.thirdPartyLocationIsActive;
    this.ThirdPartyLevel1Id = item.thirdPartyLevel1Id;
    this.ThirdPartyLevel2Id = item.thirdPartyLevel2Id;
    this.ThirdPartyLevel3Id = item.thirdPartyLevel3Id;
    this.ThirdPartyLevel4Id = item.thirdPartyLevel4Id;
    this.ThirdPartyLevel5Id = item.thirdPartyLevel5Id;
    this.JobDate = new Date(item.jobDate).getTime() ? new Date(item.jobDate) : '';
    this.OpportunityCurrencyId = item.opportunityCurrencyId;
    this.OpportunityCurrencyCode = item.opportunityCurrencyCode;
    this.OpportunityCurrencySymbol = item.opportunityCurrencySymbol;
    this.ClientFeeTotal = item.clientFeeTotal;
    this.ClientFeeTotalWithSymbol = stringHelper.getValueWithSymbol(
      '',
      item.opportunityCurrencySymbol,
      item.clientFeeTotal
    );
    this.ReimbTotal = item.reimbTotal;
    this.ReimbTotalExchanged = item.reimbTotalExchanged;
    this.ReimbTotalExchangedWithSymbol = stringHelper.getValueWithSymbol(
      '',
      item.opportunityCurrencyCode,
      item.reimbTotalExchanged
    );
    this.FieldworkFee = item.fieldworkFee;
    this.FieldworkFeeWithSymbol = stringHelper.getValueWithSymbol(
      '',
      item.opportunityCurrencySymbol,
      item.fieldworkFee
    );
    this.ReimbursementCurrencyId = item.reimbursementCurrencyId;
    this.ReimbursementCurrencySymbol = item.reimbursementCurrencySymbol;
    this.EvaluatorCurrencySymbol = item.evaluatorCurrencySymbol;
    this.EvaluatorCurrencyCode = item.evaluatorCurrencyCode;
    this.EvaluatorCurrencyId = item.evaluatorCurrencyId;
    this.EvalFeeTotal = stringHelper.getValueWithSymbol('', item.evaluatorCurrencySymbol, item.evalFeeTotal);
    this.EvalReimbursementTotal = stringHelper.getValueWithSymbol(
      '',
      item.reimbursementCurrencySymbol,
      item.evalReimbTotal
    );
    this.ClientFeeBase = item.clientFeeBase;
    this.PricingCurrencySymbol = item.pricingCurrencySymbol;
    this.ClientFeeBaseWithSymbol = stringHelper.getFeeTotal(item.pricingCurrencySymbol, [item.clientFeeBase]);
    this.PricingCurrencyCode = item.pricingCurrencyCode;
    this.IsUninvoiceable = item.isUninvoiceable;
    this.PaidOutsideOfSystem = item.paidOutsideOfSystem;
    this.CanTogglePaidOutsideOfSystem = item.canTogglePaidOutsideOfSystem;
    this.IsShopperPaidThroughApollo = item.isShopperPaidThroughApollo;
    this.TpWaveId = item.tpWaveId;
    this.TpWaveName = item.tpWaveName;
    this.TpWaveNameAndId = item.tpWaveId ? `${item.tpWaveId} - ${item.tpWaveName}` : '';
    this.Selected = false;
    this.ProjectId = item.projectId;
    this.ProjectName = item.projectName;
    this.ProjectNameAndId = item.projectId ? `${item.projectId} - ${item.projectName}` : '';
    this.TpSurveyId = item.tpSurveyId;
    this.TpSurveyName = item.tpSurveyName;
    // Both null when no automatic invoicing setup invoices the job's project. For a project on another setup's
    // invoice they are that setup's, and InvoicedWithProject names the setup's project.
    this.ProjectInvoiceAutomationIsActive = item.projectInvoiceAutomationIsActive;
    this.ProjectInvoiceAutomationRunSchedule = item.projectInvoiceAutomationRunSchedule;
    this.ProjectInvoiceAutomationInvoicedWithProjectId = item.projectInvoiceAutomationInvoicedWithProjectId ?? null;
    this.ProjectInvoiceAutomationInvoicedWithProjectName = item.projectInvoiceAutomationInvoicedWithProjectName ?? null;
    this.PricingId = item.pricingId;
    this.RoundFee = item.roundFee;
    this.ReimbursementCurrencyCode = item.reimbursementCurrencyCode;
    this.TpClientInvoiceId = item.tpClientInvoiceId;
    this.TpEvaluatorFullName = item.tpEvaluatorFullName ? item.tpEvaluatorFullName : '';
    this.AsCuid = item.asCuid;
    this.AsEvaluatorCompletedDate = item.asEvaluatorCompletedDate;
    this.ThirdPartyDeleted = item.thirdPartyDeleted;
    this.BillClient = item.billClient;
    this.Reimbursement = item.reimbursement;
    this.Status = item.status;
    this.Misc = item.misc;
    this.CurrencyCode = item.currencyCode;
    this.Travel = item.travel;
    this.ClientFee = item.clientFee;
    this.Gaming = item.gaming;
    this.AdditionalClientFeeTotal = item.additionalClientFeeTotal;
    this.ExpenseCurrencyCode = item.expenseCurrencyCode;
    this.EvaluatorReimbursement = item.evaluatorReimbursement;
    this.EvaluatorTravel = item.evaluatorTravel;
    this.EvaluatorGaming = item.evaluatorGaming;
    this.FeeCurrencyCode = item.feeCurrencyCode;
    this.ExpenseCurrencyCode = item.expenseCurrencyCode;
    this.EvaluatorMisc = item.evaluatorMisc;
    this.EvaluatorFee = item.evaluatorFee;
    this.FieldworkFee = item.fieldworkFee;
    this.PricingDetails = item.pricingDetails;
    this.GeneralFieldWorkFee = item.generalFieldWorkFee;
    this.OwningOffice = item.owningOffice;
    this.OwningOfficeFee = item.owningOfficeFee;
    this.EvaluatorFeeAdjustment = item.evaluatorFeeAdjustment;
    this.EvaluatorIds = item.evaluatorIds;
    this.TpClientInvoiceStatus = item.tpClientInvoiceStatus;
    this.MiscTotal = item.miscTotal;
    this.TpClientInvoiceJobLineCurrencyCode = item.tpClientInvoiceJobLineCurrencyCode;
    this.TravelTotal = item.travelTotal;
    this.GamingTotal = item.gamingTotal;
    this.OwningOfficeName = item.owningOfficeName;
    this.ClientReimbursementCurrencyCode = item.clientReimbursementCurrencyCode;
    this.ClientFeeCurrency = item.clientFeeCurrencyCode;
    this.EvaluatorFeeCurrencyCode = item.evaluatorFeeCurrencyCode;
    this.TotalDue = item.totalDue;
    this.TaxTotal = item.taxTotal;
    this.CurrentTotalDue = item.currentTotalDue;
    this.Credit = item.credit;
    this.TpLocationId = item.tpLocationId ? item.tpLocationId : '';
    this.ThirdPartySurveyId = item.thirdPartySurveyId ? item.thirdPartySurveyId : '';
    this.TpEvaluatorTpJobPaymentDetailExportDate = item.tpEvaluatorTpJobPaymentDetailExportDate;
    this.TpEvaluatorTpJobPaymentDetailReimbursement = item.tpEvaluatorTpJobPaymentDetailReimbursement
      ? item.tpEvaluatorTpJobPaymentDetailReimbursement
      : '';
    this.TpEvaluatorTpJobPaymentDetailTotal = item.tpEvaluatorTpJobPaymentDetailTotal
      ? item.tpEvaluatorTpJobPaymentDetailTotal
      : '';
    this.TpEvaluatorTpJobPaymentStatusCodeLookupValue = item.tpEvaluatorTpJobPaymentStatusCodeLookupValue
      ? item.tpEvaluatorTpJobPaymentStatusCodeLookupValue
      : '';
    this.TpEvaluatorTpJobPaymentDetailMisc = item.tpEvaluatorTpJobPaymentDetailMisc
      ? item.tpEvaluatorTpJobPaymentDetailMisc
      : '';
    this.TpEvaluatorTpJobPaymentDetailTravel = item.tpEvaluatorTpJobPaymentDetailTravel
      ? item.tpEvaluatorTpJobPaymentDetailTravel
      : '';
    this.TpEvaluatorTpJobPaymentDetailGaming = item.tpEvaluatorTpJobPaymentDetailGaming
      ? item.tpEvaluatorTpJobPaymentDetailGaming
      : '';
    this.TpEvaluatorTpJobPaymentDetailCurrencyId = item.tpEvaluatorTpJobPaymentDetailCurrencyId
      ? item.tpEvaluatorTpJobPaymentDetailCurrencyId
      : '';
    this.TpEvaluatorTpJobPaymentDetailFee = item.tpEvaluatorTpJobPaymentDetailFee
      ? item.tpEvaluatorTpJobPaymentDetailFee
      : '';
    this.TpEvaluatorTpJobPaymentDetailFeeAdjustment = item.tpEvaluatorTpJobPaymentDetailFeeAdjustment
      ? item.tpEvaluatorTpJobPaymentDetailFeeAdjustment
      : '';
    this.TpEvaluatorTpJobPaymentDetailVat = item.tpEvaluatorTpJobPaymentDetailVat
      ? item.tpEvaluatorTpJobPaymentDetailVat
      : '';
    this.TpEvaluatorTpJobPaymentDetailDue = item.tpEvaluatorTpJobPaymentDetailDue
      ? item.tpEvaluatorTpJobPaymentDetailDue
      : '';
    this.HasCollabJob = item.hasCollabJob ? item.hasCollabJob : false;
    this.CollabJobThirdPartyId = item.collabJobThirdPartyId ? item.collabJobThirdPartyId : '';
    this.CollabJobStatus = item.collabJobStatus ? item.collabJobStatus : '';
    this.CollabJobThirdPartySource = item.collabJobThirdPartySource ? item.collabJobThirdPartySource : '';
    this.AdHocInvoiceGroup = item.adHocInvoiceGroup ? item.adHocInvoiceGroup : '';
    this.EvaluatorOfficeName = item.evaluatorOfficeName ? item.evaluatorOfficeName : '';
    this.CampaignName = item.campaignName ? item.campaignName : '';
  }

  static displayedInList = 'Name';

  static NameOfTheIdField() {
    return 'TpJobId';
  }

  static nameOfTheItemDetailList(item) {
    let warningText = '';
    if (item) {
      if (!item.CaspianClientDetails) warningText = 'Missing Client - review Client settings';
      if (!warningText && !item.ProjectId) warningText = 'Missing Project - review Project settings';
      if (!warningText && !item.PricingId) warningText = 'Missing Country Pricing - contact Sales';
      if (!warningText && !item.JobDate) warningText = 'Missing shop date - review Shop settings';
    }

    return (
      <span>
        Third-Party Job
        {warningText && (
          <>
            {' '}
            - <span className='warningText'>{warningText}</span>
          </>
        )}
      </span>
    );
  }

  static MoneyFields = [];

  static Currency() {
    return 'CurrencyCode';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return 'CurrencyCode';
  }

  static DateFields = ['JobDate'];

  static BoolFields = ['PayEvaluator'];

  static BoolFields = ['ThirdPartyDeleted'];

  static BoolFields = ['SelfAssigned'];

  static BoolFields = ['BillClient'];

  // NOTE: this class declares `static BoolFields` six times; in JS only the last assignment survives, so
  // this is the only one that takes effect (the PayEvaluator/ThirdPartyDeleted/SelfAssigned/BillClient
  // ones above are dead). Pre-existing - add new bool fields HERE, not as a seventh declaration.
  static BoolFields = ['IsUninvoiceable'];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'ThirdPartyJobId', label: 'Third-Party Job ID', className: 'text-left' },
        { name: 'Status', label: 'Status', className: 'text-left' },
        { name: 'ThirdPartyJobStatus', label: 'Third-Party Job Status', className: 'text-left' },
        { name: (item) => TpJobItem.formatJobDate(item.JobDate), label: 'Completed On', className: 'text-left' },
        { name: 'ThirdPartySource', label: 'Source', className: 'text-left' },
        { name: 'TpLocationId', label: 'Location ID', className: 'text-left' },
        { name: 'CampaignName', label: 'Campaign', className: 'text-left' },
        {
          name: TpJobItem.getEvaluatorIds,
          label: 'Evaluator IDs',
          className: 'text-left',
        },
        { name: (item) => TpJobItem.getClientDetails(item), label: 'Client', className: 'text-left' },
        {
          name: (item) => `${item.ThirdPartyClientLocationId} - ${item.ThirdPartyLocationName}`,
          label: 'Client Location',
          className: 'text-left',
        },
        { name: 'TpEvaluatorFullName', label: 'Evaluator', className: 'text-left' },
        { name: (item) => TpJobItem.getSurveyCellContent(item), label: 'Survey', className: 'text-left' },
        { name: 'ThirdPartyLocationCountry', label: 'Country', className: 'text-left' },
        { name: 'AdHocInvoiceGroup', label: 'Ad-Hoc Invoice Group', className: 'text-left' },
        { name: (item) => TpJobItem.getWaveCellContent(item), label: 'Wave', className: 'text-left' },
        { name: (item) => TpJobItem.getProjectCellContent(item), label: 'Project', className: 'text-left' },
        { name: 'ThirdPartyDeleted', label: 'Deleted at Source System?', className: 'text-left' },
        { name: 'SelfAssigned', label: 'Self Assigned', className: 'text-left' },
        { name: 'PricingDetails', label: 'Pricing', className: 'text-left' },
        { name: 'BillClient', label: 'Bill Client?', className: 'text-left' },
        { name: 'IsUninvoiceable', label: 'Uninvoiceable', className: 'text-left' },
        {
          name: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem),
          label: 'Paid Outside of System',
          className: 'text-left',
        },
        { name: '', label: '' },
        { name: 'PayEvaluator', label: 'Pay Evaluator', className: 'text-left' },

        //Fieldwork Office section
        { name: '-message-', label: 'Fieldwork Office', className: 'text-left' },
        { name: 'FieldworkOfficeName', label: 'Fieldwork Office', className: 'text-left' },
        { name: 'GeneralFieldWorkFee', label: 'Fieldwork Fee', className: 'text-left' },

        //Owning Office section
        { name: '-message-', label: 'Owning Office', className: 'text-left' },
        { name: 'CollabJobThirdPartyId', label: 'Collab Job Third Party ID', className: 'text-left' },
        { name: 'CollabJobStatus', label: 'Collab Job Status', className: 'text-left' },
        { name: 'CollabJobThirdPartySource', label: 'Collab Job Source', className: 'text-left' },

        //Client Billing section
        { name: '-message-', label: 'Client Billing', className: 'text-left' },
        {
          name: TpJobItem.getBareInvoiceUrl,
          label: 'BARE Invoice #',
          className: 'text-left',
        },
        { name: 'ReimbTotal', label: 'Reimbursement', className: 'text-left' },
        { name: 'TotalDue', label: 'Total Due', className: 'text-left' },
        { name: 'TpClientInvoiceStatus', label: 'Status' },
        { name: 'MiscTotal', label: 'Misc' },
        { name: 'TaxTotal', label: 'Tax Total' },
        { name: 'TpClientInvoiceJobLineCurrencyCode', label: 'Currency' },
        { name: 'TravelTotal', label: 'Travel' },
        { name: 'CurrentTotalDue', label: 'Current Total Due' },
        { name: 'ClientFee', label: 'Client Fee' },
        { name: 'GamingTotal', label: 'Gaming' },
        { name: 'Credit', label: 'Credit' },
        { name: 'AdditionalClientFeeTotal', label: 'Additional Fee' },

        //Evaluator Payment section
        { name: '-message-', label: 'Evaluator Payment', className: 'text-left' },
        { name: 'TpEvaluatorTpJobPaymentDetailExportDate', label: 'Payment Export Date' },
        {
          name: 'TpEvaluatorTpJobPaymentDetailReimbursement',
          label: 'Reimbursement',
        },
        {
          name: 'TpEvaluatorTpJobPaymentDetailTotal',
          label: 'Initial Total',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={45}
              value={item.TpEvaluatorTpJobPaymentStatusCodeLookupValue}
            />
          ),
          label: 'Status',
        },
        { name: 'TpEvaluatorTpJobPaymentDetailMisc', label: 'Misc' },
        { name: 'TpEvaluatorTpJobPaymentDetailVat', label: 'Tax' }, //Todo: Discuss with Tamás
        { name: (item) => item.TpEvaluatorTpJobPaymentDetailCurrencyId, label: 'Currency' }, //Todo: CurrencyCode instead of CurrencyId
        { name: 'TpEvaluatorTpJobPaymentDetailTravel', label: 'Travel' },
        { name: 'TpEvaluatorTpJobPaymentDetailDue', label: 'Current Total Due' },
        { name: 'TpEvaluatorTpJobPaymentDetailFee', label: 'Evaluator Fee' },
        { name: 'TpEvaluatorTpJobPaymentDetailGaming', label: 'Gaming' },
        { name: '', label: '' },
        { name: 'TpEvaluatorTpJobPaymentDetailFeeAdjustment', label: 'Additional Fee' },
      ],
    },
    {
      // Assignment data was queried from vZeusAssignmentExtended
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { name: '-', label: '' },
        { name: '-message-', label: 'Owning Office', className: 'text-left' },
        { name: 'EvaluatorOfficeName', label: 'Evaluator Payment Office' },
        { name: 'OwningOfficeName', label: 'Owning Office' },
        { name: 'OpportunityCurrencyCode', label: 'Owning Office Fee Currency' },
        { name: 'OwningOfficeFee', label: 'Owning Office Fee' },
        { name: 'RoundFee', label: 'Owning Office Fee Round' },
        { name: '-', label: '' },

        //Client section
        { name: '-message-', label: 'Client', className: 'text-left' },
        { name: 'OpportunityCurrencyCode', label: 'Fee Currency' },
        { name: 'ClientReimbursementCurrencyCode', label: 'Reimbursement Currency' },
        { name: 'EvaluatorMisc', label: 'Misc' },
        { name: 'ClientFeeTotal', label: 'Fee' },
        { name: 'EvaluatorReimbursement', label: 'Reimbursement' },
        { name: 'EvaluatorTravel', label: 'Travel' },
        { name: 'FieldworkFee', label: 'Fieldwork Fee' },
        { name: '', label: '' },
        { name: 'EvaluatorGaming', label: 'Gaming' },
        { name: '', label: 'Additional Fee' },
        { name: '', label: '' },
        { name: '-', label: '' },

        //Evaluator section
        { name: '-message-', label: 'Evaluator', className: 'text-left' },
        { name: 'EvaluatorFeeCurrencyCode', label: 'Fee Currency' },
        { name: 'OpportunityCurrencyCode', label: 'Reimbursement Currency' },
        { name: 'EvaluatorMisc', label: 'Misc' },
        { name: 'EvaluatorFee', label: 'Fee' },
        { name: 'EvaluatorReimbursement', label: 'Reimbursement' },
        { name: 'EvaluatorTravel', label: 'Travel' },
        { name: 'EvaluatorFeeAdjustment', label: 'Additional Fee' },
        { name: '', label: '' },
        { name: 'EvaluatorGaming', label: 'Gaming' },
      ],
    },
  ];

  static getStatusCellContent(item) {
    let shownStatus = item.ThirdPartyJobStatus ? item.ThirdPartyJobStatus : ' ';
    switch (shownStatus) {
      case 'Approved For Controlled Release':
        shownStatus = 'Approved CR';
        break;

      // Add more cases here if needed in the future

      default:
        // shownStatus remains unchanged
        break;
    }
    return (
      <LongText
        text={shownStatus}
        maxLength={30}
      />
    );
  }

  static getStatusCellWarningContent(item) {
    return item.HasCollabJob && item.CollabJobStatus != item.ThirdPartyJobStatus ? (
      <span className='warningText'>{item.ThirdPartyJobStatus}</span>
    ) : (
      TpJobItem.getStatusCellContent(item)
    );
  }

  static getProjectCellContent(item) {
    return (
      <LongText
        text={`${item.ProjectNameAndId}`}
        maxLength={12}
      />
    );
  }
  static formatJobDate(date) {
    if (!date) return '';
    const formattedDate = new Date(date).toLocaleDateString();
    return formattedDate;
  }

  static getTpEvaluatorFullName(item) {
    return (
      <LongText
        text={`${item.TpEvaluatorFullName}`}
        maxLength={30}
      />
    );
  }

  static getClientDetails(item) {
    return (
      <LongText
        text={`${item.CaspianClientDetails}`}
        maxLength={30}
      />
    );
  }

  static getSurveyCellContent(item) {
    return (
      <LongText
        text={`${item.ThirdPartySurveyId} - ${item.TpSurveyName}`}
        maxLength={25}
      />
    );
  }

  // Written as the Survey filter lists the survey, so a row can be matched to its option there.
  static getSurveyNameAndIdCellContent(item) {
    return (
      <LongText
        text={stringHelper.toNameWithBracketedId(item.TpSurveyName, item.ThirdPartySurveyId)}
        maxLength={30}
      />
    );
  }

  static getWaveCellContent(item) {
    return (
      <LongText
        text={item.TpWaveNameAndId}
        maxLength={12}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={TpJobItem.selectedStatus()}
          onChange={(e) => {
            TpJobItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static selectedStatus() {
    return false;
  }

  static clickOnGlobalSelect(item, selected) {}

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            TpJobItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        path='tpjobs'
        tooltipText={item.ThirdPartyJobId}
        isFigmaStyle={true}
        text={item.ThirdPartyJobId}
        keyValuePairs={[
          { key: 'SelectedFieldworkOfficeIds', value: '' },
          { key: 'TpJobId', value: item.TpJobId },
        ]}
      />
    );
  }

  static clickOnSelect(item, selected) {}
  static getEvaluatorIds(item) {
    return (
      <LongText
        text={item.EvaluatorIds}
        separator=','
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Third-Party Job ID',
        orderById: 'ThirdPartyJobId',
        data: 'ThirdPartyJobId',
        minWidth: 50,
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      {
        label: 'Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
        minWidth: 50,
      },
      {
        label: 'Project',
        orderById: 'ProjectNameAndId',
        data: TpJobItem.getProjectCellContent,
        minWidth: 150,
      },
      {
        label: 'Survey Associated',
        orderById: 'TpSurveyName',
        data: (item) => (
          <LongText
            text={item.TpSurveyName}
            maxLength={30}
          />
        ),
        minWidth: 50,
      },
      { label: 'Country', orderById: 'ThirdPartyLocationCountry', data: 'ThirdPartyLocationCountry', minWidth: 50 },
      {
        label: 'Status',
        orderById: 'Status',
        data: 'Status',
        minWidth: 30,
      },
      {
        label: 'Third Party Job Status',
        orderById: 'ThirdPartyJobStatus',
        data: TpJobItem.getStatusCellContent,
        minWidth: 30,
      },
      {
        label: 'Completed On',
        orderById: 'JobDate',
        data: 'JobDate',
        minWidth: 50,
      },
      {
        label: 'Client',
        orderById: 'CaspianClientDetails',
        data: TpJobItem.getClientDetails,
        minWidth: 50,
      },
      {
        label: 'Evaluator',
        orderById: 'TpEvaluatorFullName',
        data: TpJobItem.getTpEvaluatorFullName,
        minWidth: 50,
      },
      {
        label: ' ',
        orderById: '',
        data: TpJobItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  // The per-fee fields (EvaluatorFee, EvaluatorReimbursement, ...) arrive as text, and as a message such as
  // "No EvaluatorFee (1)" when the job has no fee record - kept for the detail view. Money cells need a number:
  // parseFloat turned the message into NaN, and "+" on two of the texts concatenated them.
  static getFeeAmount(value) {
    const amount = parseFloat(value);
    return Number.isFinite(amount) ? amount : null;
  }

  static badgeFunction(item) {
    return (
      <FigmaBadge
        Active={item}
        ActiveText='Yes'
        InactiveText='No'
        width={50}
      />
    );
  }

  static tpJobPaymentsFunction = (item) => {
    alert('Empty function');
  };

  // CD-5421: bound by TpJobAdmin, same pattern as tpJobPaymentsFunction above.
  static paidOutsideOfSystemFunction = (item) => {
    alert('Empty function');
  };

  static isPaidOutsideOfSystem(item) {
    return paidOutsideOfSystemHelper.IsPaidOutsideOfSystem(item);
  }

  static getBareInvoiceUrl(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.TpClientInvoiceId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'tpclientinvoicedetails',
      `id=${item.TpClientInvoiceId}`,
      'Open up in a new tab'
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-money-check-alt',
            roleKey: 'Evaulator_faicon_EvaluatorPaymentsButton',
            text: 'Third-Party Job Payments',
            onClick: () => TpJobItem.tpJobPaymentsFunction(item),
          },
          {
            text: 'Third-Party Job Payments (Admin)',
            iconName: 'fa-solid fa-magnifying-glass',
            url: `/tpevaluatortpjobpayments/search?ThirdPartyJobId=${item.ThirdPartyJobId}&SelectedPaymentOffices=`,
            hide: !AuthService.IsAdmin(),
          },
          {
            // CD-5421: disabled when a payment on this job is already exported. The server re-checks and
            // can still refuse (it also considers queued/running exports), so this is an affordance only.
            iconName: 'fa-solid fa-hand-holding-dollar',
            roleKey: 'assignment_edit',
            text: paidOutsideOfSystemHelper.GetToggleActionText(item),
            disabled: item.CanTogglePaidOutsideOfSystem !== true,
            onClick: () => TpJobItem.paidOutsideOfSystemFunction(item),
          },
        ]}
      />
    );
  }
}
